import type { ReactElement } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Accounts from './pages/Accounts';
import Trades from './pages/Trades';
import Calendar from './pages/Calendar';
import News from './pages/News';
import Portfolio from './pages/Portfolio';
import Payouts from './pages/Payouts';
import Settings from './pages/Settings';
import Admin from './pages/Admin';
import Bitacora from './pages/Bitacora';
import Estrategia from './pages/Estrategia';
import FondoBitacora from './pages/FondoBitacora';
import FondoReglas from './pages/FondoReglas';

export default function App(): ReactElement {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts"
            element={
              <ProtectedRoute>
                <Accounts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/trades"
            element={
              <ProtectedRoute>
                <Trades />
              </ProtectedRoute>
            }
          />
          <Route
            path="/calendar"
            element={
              <ProtectedRoute>
                <Calendar />
              </ProtectedRoute>
            }
          />
          <Route
            path="/news"
            element={
              <ProtectedRoute>
                <News />
              </ProtectedRoute>
            }
          />
          <Route
            path="/portfolio"
            element={
              <ProtectedRoute>
                <Portfolio />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payouts"
            element={
              <ProtectedRoute>
                <Payouts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute requireRole="admin">
                <Admin />
              </ProtectedRoute>
            }
          />
          {/* Bitácora + Mi Estrategia: personales de Maxi (admin-only). Un user
              normal que escriba la URL es redirigido al dashboard. */}
          <Route
            path="/bitacora"
            element={
              <ProtectedRoute requireRole="admin">
                <Bitacora />
              </ProtectedRoute>
            }
          />
          <Route
            path="/estrategia"
            element={
              <ProtectedRoute requireRole="admin">
                <Estrategia />
              </ProtectedRoute>
            }
          />
          {/* Fondo Cripto (Plutus): espacio del fondo común, admin-only. Separado
              del trading personal. /fondo redirige a su bitácora. */}
          <Route path="/fondo" element={<Navigate to="/fondo/bitacora" replace />} />
          <Route
            path="/fondo/bitacora"
            element={
              <ProtectedRoute requireRole="admin">
                <FondoBitacora />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fondo/reglas"
            element={
              <ProtectedRoute requireRole="admin">
                <FondoReglas />
              </ProtectedRoute>
            }
          />
          {/* Fallback: cualquier ruta desconocida → home (que decide login/dashboard) */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}
